import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useEffect, useState } from "react";
// Material Dashboard 2 React base styles
import breakpoints from "assets/theme/base/breakpoints";
export const StrengthComponent = ({ strength }) => {
  return (
    <Grid container spacing={window.innerWidth < breakpoints.values.lg ? 2 : 5} alignItems="center">
      <Grid item justifyContent="center" textAlign="center">
        <MDTypography
          color={strength?.correctLength ? "primary" : "text"}
          fontWeight="bold"
          fontSize="xll"
          sx={({ breakpoints }) => ({
            [breakpoints.down("xl")]: {
              fontSize: "12px",
            },
          })}
        >
          + ۸
        </MDTypography>
        <MDTypography
          sx={({ breakpoints }) => ({
            [breakpoints.down("xl")]: {
              fontSize: "10px",
            },
          })}
          color={strength?.correctLength ? "primary" : "text"}
        >
          حداقل 8 کارکتر
        </MDTypography>
      </Grid>
      <Grid item textAlign="center">
        <MDTypography
          color={strength?.hasNumber ? "primary" : "text"}
          fontWeight="bold"
          fontSize="xll"
          sx={({ breakpoints }) => ({
            [breakpoints.down("xl")]: {
              fontSize: "12px",
            },
          })}
        >
          ۲
        </MDTypography>
        <MDTypography
          sx={({ breakpoints }) => ({
            [breakpoints.down("xl")]: {
              fontSize: "10px",
            },
          })}
          color={strength?.hasNumber ? "primary" : "text"}
        >
          عدد
        </MDTypography>
      </Grid>
      <Grid item textAlign="center">
        <MDTypography
          color={strength?.hasSpecial ? "primary" : "text"}
          fontWeight="bold"
          fontSize="xll"
          sx={({ breakpoints }) => ({
            [breakpoints.down("xl")]: {
              fontSize: "12px",
            },
          })}
        >
          @
        </MDTypography>
        <MDTypography
          sx={({ breakpoints }) => ({
            [breakpoints.down("xl")]: {
              fontSize: "10px",
            },
          })}
          color={strength?.hasSpecial ? "primary" : "text"}
        >
          کارکتر خاص
        </MDTypography>
      </Grid>
      <Grid item textAlign="center">
        <MDTypography
          color={strength?.hasCaital ? "primary" : "text"}
          fontWeight="bold"
          fontSize="xll"
          sx={({ breakpoints }) => ({
            [breakpoints.down("xl")]: {
              fontSize: "12px",
            },
          })}
        >
          A
        </MDTypography>
        <MDTypography
          sx={({ breakpoints }) => ({
            [breakpoints.down("xl")]: {
              fontSize: "10px",
            },
          })}
          color={strength?.hasCaital ? "primary" : "text"}
        >
          حروف بزرگ
        </MDTypography>
      </Grid>
      <Grid item textAlign="center">
        <MDTypography
          color={strength?.hasSmall ? "primary" : "text"}
          fontWeight="bold"
          fontSize="xll"
          sx={({ breakpoints }) => ({
            [breakpoints.down("xl")]: {
              fontSize: "12px",
            },
          })}
        >
          a
        </MDTypography>
        <MDTypography
          sx={({ breakpoints }) => ({
            [breakpoints.down("xl")]: {
              fontSize: "10px",
            },
          })}
          color={strength?.hasSmall ? "primary" : "text"}
        >
          حروف کوچک
        </MDTypography>
      </Grid>
    </Grid>
  );
};
